/**
 * 
 * @param {date} date 
 * @returns a string with the format ddmmyyyy
 */
export function formatDate(date){
    try {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so we add 1
        const day = String(date.getDate()).padStart(2, '0');

        return `${day}${month}${year}`;
    } catch (error) {
        console.log(error)
        return null;
    }
}